export enum UploadStatus {
  UPLOADING = 'uploading',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
}
